import styles from './RaspadinhaContemplatedPrizeProgressBar.module.css'

type RaspadinhaContemplatedPrizeProgressBarProps = {
  fulfilledCount: number
  scheduledCount: number
  prizeLabel: string
}

function clampCount(value: number): number {
  if (!Number.isFinite(value) || value < 0) {
    return 0
  }

  return Math.floor(value)
}

export function RaspadinhaContemplatedPrizeProgressBar({
  fulfilledCount,
  scheduledCount,
  prizeLabel,
}: RaspadinhaContemplatedPrizeProgressBarProps) {
  const safeScheduled = clampCount(scheduledCount)
  const safeFulfilled = clampCount(fulfilledCount)
  const fillPercent =
    safeScheduled === 0 ? 0 : Math.min(100, (safeFulfilled / safeScheduled) * 100)

  const countLabel =
    safeScheduled === 0
      ? '0 previstos'
      : `${safeFulfilled} de ${safeScheduled}`

  const statusLabel =
    safeScheduled === 0
      ? 'Nenhum horário vinculado na aba Contemplações.'
      : safeFulfilled >= safeScheduled
        ? 'Todas as contemplações previstas foram registradas.'
        : `${safeScheduled - safeFulfilled} contemplação(ões) pendente(s).`

  return (
    <div
      className={styles.wrapper}
      role="group"
      aria-label={`Progresso de contemplações do prêmio ${prizeLabel}`}
    >
      <div className={styles.headerRow}>
        <span className={styles.caption}>Contemplações</span>
        <div className={styles.counts}>
          <span className={styles.countValue}>{countLabel}</span>
          <span className={styles.countHint}>contemplados</span>
        </div>
      </div>

      <div
        className={styles.track}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={safeScheduled}
        aria-valuenow={safeFulfilled}
        aria-valuetext={`${safeFulfilled} de ${safeScheduled} contemplações registradas`}
      >
        <div
          className={styles.fill}
          style={{ ['--progress-fill' as string]: `${fillPercent}%` }}
        />
      </div>

      <p className={styles.statusHint}>{statusLabel}</p>
    </div>
  )
}
